const hardcodedSystemAdminEmails = new Set([
  'pris@superflow.team',
  'mark@superflow.team',
  'mark+2@superflow.team', // localhost for prod
  'matyi@superflow.team',
  'krisztian@superflow.team',
]);

export function isSystemAdmin(user?: { email?: string }) {
  return user && user.email && hardcodedSystemAdminEmails.has(user.email);
}
